/**
 * Created by stanleyw on 1/24/2018.
 */
import { Injectable } from '@angular/core';
import { LMContextService } from './lm-context.service';

@Injectable()
export class LMHarnessService {

  constructor(
    private lmContextService: LMContextService,
  ) {
    this.getHarness();
  }

  isXiFull(): boolean {
    return (this.getHarness() === 'xifull');
  }

  isXiHarness(): boolean {
    return (this.getHarness() === 'xiharness');
  }

  is3xHarness(): boolean {
    return (this.getHarness() === '3xharness');
  }

  private getHarness(): string {
    const context: LMContext = this.lmContextService.getContext();
    const xiHarness: boolean = context.uiHarness === 'xiharness';
    const harness3x: boolean = context.uiHarness === '3xharness';
    const cskNg: boolean = context.contextSessionKeys !== undefined && context.contextSessionKeys[ 'csk.ng' ] ? context.contextSessionKeys[ 'csk.ng' ] : false;

    let retHarness = 'xiharness';

    if (cskNg) {
      retHarness = 'xiharness';
    } else if (xiHarness || harness3x) {
      retHarness = context.uiHarness;
    } else {
      retHarness = 'xiharness';
    }

    return retHarness;
  }
}
